import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-style7_home",
  "use": "icon-style7_home-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-style7_home\">\r\n<g>\r\n\t<path class=\"st0\" d=\"M192.6,109.3L100,16.6L7.4,109.3h23.2v81.1h139.7v-81.1H192.6z M46.6,174.4V92.7L100,39.2l54.3,54.4v80.8H46.6\r\n\t\tz\" />\r\n\t<rect x=\"85.1\" y=\"124.2\" class=\"st0\" width=\"29.3\" height=\"41.7\" />\r\n\t<polygon class=\"st0\" points=\"166.2,20.9 141,20.9 141,39.7 166.2,64.6 \t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol